var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[_c('el-header',[(_vm.isAuthenticated)?_c('navigation'):_vm._e()],1),_c('el-main',[_c('div',{staticClass:"main-container"},[_c('center-container',[_c('router-view')],1)],1)])],1)}
var staticRenderFns = []

export { render, staticRenderFns }